import { render, staticRenderFns } from "./OverlayBackdrop.vue?vue&type=template&id=72492790&"
import script from "./OverlayBackdrop.vue?vue&type=script&lang=js&"
export * from "./OverlayBackdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports